<template>
	<div class="base-transition-container">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		updated() {
			const target = this.$el;
			this.$anime.timeline({
				duration: 333,
				easing: 'easeInOutQuad',
			}).add({
				targets: target,
				keyframes:[{
					opacity: 0,
					duration: 0,
					translateY: -100,
				},
				{
					opacity: 1,
					duration: 333,
					translateY: 0,
				}],
			});
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	@include mobile {}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseTransition.vue